<!-- 产品属性 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">样式设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData" label-position="right" :label-width="100" >
                        <div class="form-title">选择样式</div>
                        <FormItem label="选择样式">
                            <RadioGroup v-model="newFormData.content.style_value" >
                                <Radio class="mr-24" label="1">样式一</Radio>
                                <Radio class="mr-24" label="2">样式二</Radio>
                                <Radio class="mr-24" label="3">样式三</Radio>
                            </RadioGroup>
                        </FormItem>
                        <div class="form-title">属性标题</div>
                        <FormItem label="标题文字">
                            <Input v-model="newFormData.content.title" placeholder="请输入标题文字" ><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem label="文字大小">
                            <Input v-model="newFormData.content.title_size" placeholder="请输入文字大小" ><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem v-if="newFormData.content.style_value != 1" label="文字位置" >
                            <RadioGroup v-model="newFormData.content.position" type="button" >
                                <Radio label="left" ><Icon type="md-menu" /></Radio>
                                <Radio label="center" ><Icon type="md-funnel" /></Radio>
                                <Radio label="right" ><Icon type="md-menu" /></Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker v-model="newFormData.content.title_color" />
                        </FormItem>
                        <FormItem v-if="newFormData.content.style_value == 1" label="装饰颜色" >
                            <ColorPicker v-model="newFormData.content.dec_color" />
                        </FormItem>
                        <FormItem v-if="newFormData.content.style_value == 3" label="装饰颜色" >
                            <ColorPicker v-model="newFormData.content.border_color" />
                        </FormItem>
                        <FormItem label="分割线颜色">
                            <ColorPicker v-model="newFormData.content.title_border_color" />
                        </FormItem>
                        <FormItem label="标题背景">
                            <ColorPicker v-model="newFormData.content.title_bg_color" />
                        </FormItem>
                        <div class="form-title">内容设置</div>
                        <FormItem label="名称大小">
                            <Input v-model="newFormData.content.text_size" placeholder="请输入名称大小" ><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem label="名称颜色">
                            <ColorPicker v-model="newFormData.content.text_color" />
                        </FormItem>
                        <FormItem label="内容大小">
                            <Input v-model="newFormData.content.txt_size" placeholder="请输入内容大小" ><span slot="append">PX</span></Input>
                        </FormItem>
                        <FormItem label="内容颜色">
                            <ColorPicker v-model="newFormData.content.txt_color" />
                        </FormItem>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker v-model="newFormData.content.bg_color" />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch v-model="newFormData.content.bg_value" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeBgValue">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem v-if="newFormData.content.bg_value" label="上传背景">
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img class="bg-img" v-if="newFormData.content.bg_img.picview" :src="newFormData.content.bg_img.picview"/>
                                <Icon v-else type="md-add" size="30" color="#ccc"/>
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="right" :label-width="80">
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.top"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.bottom"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary 
            v-if="switch_modal" 
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: #ff761d;
    color: #ff761d;
    box-shadow: -1px 0 0 0 #ff761d;
}
::v-deep .ivu-radio-group-button :hover {
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>